/* RL ELVARIM — utilidades compartidas: carruseles (flechas + puntos), vídeos con póster, anclas a la compra y cuenta atrás.
   Se carga UNA vez desde la primera sección de la plantilla. Idempotente. ES5 a propósito. */
(function(){
  if(window.__rleLoaded) return; window.__rleLoaded=1;
  function stepOf(tr){ var c=tr.children[0]; if(!c) return tr.clientWidth; var g=parseFloat(getComputedStyle(tr).columnGap||getComputedStyle(tr).gap)||14; return c.getBoundingClientRect().width+g; }
  function bindCar(root){
    if(root.getAttribute('data-rle-bound')) return; root.setAttribute('data-rle-bound','1');
    var tr=root.querySelector('.rle-track'); if(!tr) return;
    var pv=root.querySelector('[data-rle-prev]'), nx=root.querySelector('[data-rle-next]'), dots=root.querySelector('.rle-dots'), ar=root.querySelector('.rle-arrows');
    function pages(){ var st=stepOf(tr); return Math.max(1, Math.round((tr.scrollWidth-tr.clientWidth)/st)+1); }
    function idx(){ return Math.round(tr.scrollLeft/stepOf(tr)); }
    function drawDots(){ if(!dots) return; var n=pages(), h=''; for(var k=0;k<n;k++){ h+='<span'+(k===0?' class="on"':'')+'></span>'; } dots.innerHTML=h; dots.style.display=n>1?'':'none'; }
    function sync(){
      var max=tr.scrollWidth-tr.clientWidth-4, fit=tr.scrollWidth<=tr.clientWidth+4;
      if(ar) ar.style.display=fit?'none':'';
      if(pv) pv.disabled=tr.scrollLeft<=4; if(nx) nx.disabled=tr.scrollLeft>=max;
      if(dots){ var s=dots.children, i=Math.min(idx(), s.length-1); for(var k=0;k<s.length;k++){ s[k].className=(k===i?'on':''); } }
    }
    if(pv) pv.addEventListener('click',function(){ tr.scrollBy({left:-stepOf(tr),behavior:'smooth'}); });
    if(nx) nx.addEventListener('click',function(){ tr.scrollBy({left:stepOf(tr),behavior:'smooth'}); });
    tr.addEventListener('scroll',sync,{passive:true});
    window.addEventListener('resize',function(){ drawDots(); sync(); });
    var imgs=tr.querySelectorAll('img'); for(var i=0;i<imgs.length;i++){ imgs[i].addEventListener('load',function(){ drawDots(); sync(); }); }
    root.__rleSync=function(){ drawDots(); sync(); };
    drawDots(); sync();
  }
  function pauseOthers(v){ var all=document.querySelectorAll('video'); for(var k=0;k<all.length;k++){ if(all[k]!==v && !all[k].paused){ try{ all[k].pause(); }catch(e){} } } }
  function bindVid(el){
    if(el.getAttribute('data-rle-bound')) return; el.setAttribute('data-rle-bound','1');
    if(!el.getAttribute('data-src')) return;
    el.addEventListener('click',function(){
      if(el.getAttribute('data-rle-playing')) return; el.setAttribute('data-rle-playing','1');
      var v=document.createElement('video'); v.src=el.getAttribute('data-src'); v.controls=true; v.playsInline=true; v.setAttribute('playsinline',''); v.setAttribute('preload','auto');
      var pi=el.querySelector('img'); if(pi){ v.poster=pi.getAttribute('src'); }
      el.innerHTML=''; el.appendChild(v); pauseOthers(v); var p=v.play(); if(p&&p.catch){ p.catch(function(){}); }
    });
  }
  if(!window.__rleplay){ window.__rleplay=1; document.addEventListener('play',function(e){ if(e.target&&e.target.tagName==='VIDEO'){ pauseOthers(e.target); } },true); }
  function bindJump(a){
    if(a.getAttribute('data-rle-bound')) return; a.setAttribute('data-rle-bound','1');
    a.addEventListener('click',function(e){ var t=document.getElementById('rle-comprar'); if(!t) return; e.preventDefault(); t.scrollIntoView({behavior:'smooth',block:'start'}); });
  }
  function bindTimer(el){
    if(el.getAttribute('data-rle-bound')) return; el.setAttribute('data-rle-bound','1');
    var h=el.querySelector('[data-h]'), m=el.querySelector('[data-m]'), s=el.querySelector('[data-s]');
    var dur=(parseInt(el.getAttribute('data-rle-timer'),10)||2)*3600, key='rleTimerEnd', end=0;
    try{ end=parseInt(sessionStorage.getItem(key),10)||0; }catch(e){}
    var now=Date.now(); if(!end||end<now){ end=now+dur*1000; try{ sessionStorage.setItem(key,String(end)); }catch(e){} }
    function p2(n){ return (n<10?'0':'')+n; }
    function tick(){ var r=Math.max(0,Math.round((end-Date.now())/1000)); if(r===0){ end=Date.now()+dur*1000; try{ sessionStorage.setItem(key,String(end)); }catch(e){} r=dur; }
      if(h) h.textContent=p2(Math.floor(r/3600)); if(m) m.textContent=p2(Math.floor(r%3600/60)); if(s) s.textContent=p2(r%60); }
    tick(); setInterval(tick,1000);
  }
  function init(){
    var i, a=document.querySelectorAll('[data-rle-car]'); for(i=0;i<a.length;i++) bindCar(a[i]);
    a=document.querySelectorAll('[data-rle-vid]'); for(i=0;i<a.length;i++) bindVid(a[i]);
    a=document.querySelectorAll('[data-rle-jump]'); for(i=0;i<a.length;i++) bindJump(a[i]);
    a=document.querySelectorAll('[data-rle-timer]'); for(i=0;i<a.length;i++) bindTimer(a[i]);
  }
  if(document.readyState==='loading'){ document.addEventListener('DOMContentLoaded',init); } else { init(); }
  window.addEventListener('load',function(){ var a=document.querySelectorAll('[data-rle-car]'); for(var i=0;i<a.length;i++){ if(a[i].__rleSync) a[i].__rleSync(); } });
  document.addEventListener('shopify:section:load',init);
})();
/* Añadir al carrito (packs): /cart/add.js + cajón del tema (window.mlCartOpen) */
window.rleAdd=window.rleAdd||function(btn,vid){
  btn.disabled=true;
  fetch('/cart/add.js',{method:'POST',headers:{'Content-Type':'application/json','Accept':'application/json'},body:JSON.stringify({items:[{id:parseInt(vid,10),quantity:1}]})})
    .then(function(r){ return r.json(); })
    .then(function(){ btn.disabled=false; if(window.mlCartOpen){ window.mlCartOpen(); } else { window.location.href='/cart'; } })
    .catch(function(){ btn.disabled=false; window.location.href='/cart'; });
};
